import { VTooltip } from 'floating-vue'

export default VTooltip
